import React, { useCallback } from "react";
import { useEffect, useState, useRef, useMemo } from "react";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { ucMenus } from "globals/configuration/uc";
import { application } from "globals/endpoints";
import SidebarCollapse from "./SidebarCollapse";
import SidebarList from "./SidebarList";
import SideBarItem from "./SideBarItem";
import SidebarRoot from "./SidebarRoot";
import sidebarLogoLabel from "./styles/sidebar";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import { ivrMenus } from "globals/configuration/ivr/menu";
import { callCenterMenus } from "globals/configuration/call-center/menu";
import { kmAdminMenus } from "globals/configuration/kmAdmin";
import { Menus } from "globals/configuration/changePass";
import { quickMenus } from "globals/configuration/quickMenus";
import { ucNotificationMenus } from "globals/configuration/ucNotification";
import { nmsQuickMenus } from "globals/configuration/nmsQuickMenus";
import { configurationMenus } from "globals/configuration/configurationMenu";
import CTLUserStatus from "../CTLUserStatus";
import CryptoJS from "crypto-js";
import CloseIcon from "@mui/icons-material/Close";
import NotificationManager from "globals/websocket/WebSocket";
import { setDispatcherEvent } from "context";
import MuiAlert from "@mui/material/Alert";
import {
  useMaterialUIController,
  setMiniSidenav,
  setActivePage,
  setSearchText,
  setProfileStatus,
  setManualCall,
} from "context";
import { adminMenus } from "globals/configuration/admin";
import { groupQuickMenus } from "globals/configuration/groupQuickMenus";
import { conferenceQuickMenus } from "globals/configuration/ConferenceQuickMenu";
import loggerFactory from "globals/logger/logger-factory";
import { dispatcherQuickMenus } from "globals/configuration/RailwayDispatcherQuickMenus";
import {
  Alert,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Slide,
  Snackbar,
  TextField,
  Tooltip,
} from "@mui/material";
import CTLDialogContent from "../styles/CTLDialogContent";
import MDInput from "components/MDInput";
import { Padding, Visibility, VisibilityOff } from "@mui/icons-material";
import MDButton from "components/MDButton";
import CTLNotification from "../CTLNotification";
import MDBadge from "components/MDBadge";
import { setCallInWaiting } from "context";
import { chatMenus } from "globals/configuration/chatMenus";
import { emailMenus } from "globals/configuration/emailMenu";
import { agentReportMoreVert } from "globals/configuration/agentReportMoreVert";
import ControlServerComponent from "../ControlServerComponent";
import notificationSound from "assets/sound/notificationSound.wav";
import { agentMenus } from "globals/configuration/agent";
function CTLSideBar({ color, brand, brandName, routes, ...rest }) {
  const [openCollapse, setOpenCollapse] = useState(false);
  const [openNestedCollapse, setOpenNestedCollapse] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const [open, setOpen] = useState(false);
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    activePage,
    profileStatus,
    manualCall,
  } = controller;
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];
  const items = activePage.url.split("/").slice(1);
  const itemParentName = items[1];
  const itemName = items[items.length - 1];
  const [Password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [count, setCount] = useState(0);
  const [notificationsByUser, setNotificationsByUser] = useState({});

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    status: "",
    type: "",
  });

  // Load notifications from localStorage on mount
  useEffect(() => {
    try {
      const storedNotifications = localStorage.getItem("chat-notifications-by-user");
      if (storedNotifications) {
        const parsed = JSON.parse(storedNotifications);
        setNotificationsByUser(parsed);
        // Calculate total count
        const totalCount = Object.values(parsed).reduce((sum, item) => sum + item.count, 0);
        setCount(totalCount);
      }
    } catch (e) {
      console.error("Error loading notifications from localStorage:", e);
    }
  }, []);

  // Save notifications to localStorage whenever they change
  useEffect(() => {
    try {
      localStorage.setItem("chat-notifications-by-user", JSON.stringify(notificationsByUser));
      const totalCount = Object.values(notificationsByUser).reduce((sum, item) => sum + item.count, 0);
      setCount(totalCount);
    } catch (e) {
      console.error("Error saving notifications to localStorage:", e);
    }
  }, [notificationsByUser]);

  const incrementNotificationForUser = (userId, userName, message) => {
    setNotificationsByUser((prev) => {
      const existing = prev[userId] || { count: 0, userName, messages: [] };
      return {
        ...prev,
        [userId]: {
          count: existing.count + 1,
          userName: userName || userId,
          messages: [...existing.messages, {
            content: message,
            timestamp: new Date().toISOString()
          }].slice(-10) // Keep only last 10 messages
        }
      };
    });
  };

  const clearNotificationsForUser = (userId) => {
    setNotificationsByUser((prev) => {
      const updated = { ...prev };
      delete updated[userId];
      return updated;
    });
  };

  useEffect(() => {
    if (AuthenticationService.allowRailwayDispatcher() || AuthenticationService.allowMCXDispatcher()) {
      NotificationManager.receiveMessageForMCX(
        `mcx${AuthenticationService.getExtensionNumber()}`,
        mcxUpdate,
        `mcx${AuthenticationService.getExtensionNumber()}`
      );
    }
  }, [activePage]);

  const mcxUpdate = (message) => {
    if (!message) return;
    const mcxEvent = JSON.parse(message.body);
    setDispatcherEvent(dispatch, mcxEvent);
    console.log("mcxEvent", mcxEvent);

    if (mcxEvent.messageType === "broadcast-text-message") {
      try {
        const innerMessage = mcxEvent.message;
        if (
          typeof innerMessage === "string" &&
          !innerMessage.includes("messageType=call") &&
          !innerMessage.includes("messageType=others") &&
          !innerMessage.includes("messageType=video") &&
          !innerMessage.includes("messageType=audio") &&
          !innerMessage.includes("messageType=PlayPublishVideo") &&
          !innerMessage.includes("messageType=StopPublishVideo") &&
          !innerMessage.includes("messageType=liveConferenceDisconnect")
        ) {
          const receiverMatch = innerMessage.match(/receiver=(\d+)/);
          const contentMatch = innerMessage.match(
            /content=(.*?)(?=,\s*messageType=)/
          );
          const senderMatch = innerMessage.match(/sender=(\d+)/);
          const createdAtMatch = innerMessage.match(/createdAt=([\d\-T:\.]+)/);
          const messageTypeMatch = innerMessage.match(/messageType=([^,]+)/);

          const parsedMessage = {
            receiver: receiverMatch ? receiverMatch[1] : null,
            content: contentMatch ? contentMatch[1] : "",
            sender: senderMatch
              ? senderMatch[1]
              : mcxEvent.userName || "unknown",
            createdAt: createdAtMatch ? createdAtMatch[1] : "",
            messageType: messageTypeMatch ? messageTypeMatch[1] : "text",
          };


          const receiver = parsedMessage.receiver;
          const sender = parsedMessage.sender;
          const currentUser = AuthenticationService.getExtensionNumber();

          // Only process if message is not from current user
          if (sender !== currentUser && receiver) {
            const departmentList = AuthenticationService.getDepartmentList() || [];
            const isGroup = departmentList.some(g => g.extension === receiver);
            
            // Determine notification ID based on message type:
            // - For group messages: use receiver (group extension)
            // - For direct messages to current user: use sender
            let notificationId;
            let notificationName;
            
            if (isGroup) {
              // Group message - show notification on group
              notificationId = receiver;
              const group = departmentList.find(g => g.extension === receiver);
              notificationName = group?.departmentDescription || `Group ${receiver}`;
            } else {
              // Direct message - show notification on sender
              notificationId = sender;
              notificationName = `User ${sender}`;
            }

            // Check if this chat is currently opened
            const isCurrentlyOpened = window.currentOpenedChat && 
                                     window.currentOpenedChat.id === notificationId;

            // Only show notification if chat is not currently opened
            if (activePage.key !== "chat" || !isCurrentlyOpened) {
              console.log(
                "Notification - Receiver:",
                receiver,
                "Sender:",
                sender,
                "NotificationID:",
                notificationId,
                "Name:",
                notificationName,
                "IsGroup:",
                isGroup,
                "Currently Opened:",
                isCurrentlyOpened
              );
              
              incrementNotificationForUser(notificationId, notificationName, parsedMessage.content);
              
              // Only show popup notification if chat page is not active
              if (activePage.key !== "chat") {
                handleNotification(parsedMessage);
              }
            } else {
              console.log(
                "Message received for currently opened chat:",
                notificationId,
                "- Not showing notification"
              );
            }
          }
        }
      } catch (e) {
        console.error("Parse error", e);
        setNotify({
          pagename: "Chat",
          isOpen: true,
          status: "Message parse error",
          type: "error",
        });
      }
    }
  };

  const [notifications, setNotifications] = useState([]);
  const audioRefs = {
    notificationSound,
  };

  const audioPlayingRef = useRef(null);

  const playSound = (key) => {
    if (!audioRefs[key]) return;
    if (!audioPlayingRef.current) {
      audioPlayingRef.current = new Audio(audioRefs[key]);
      audioPlayingRef.current.loop = false;
      audioPlayingRef.current.currentTime = 0;

      audioPlayingRef.current.play().catch((err) => {
        console.warn("Audio play prevented:", err);
      });

      audioPlayingRef.current.onended = () => {
        audioPlayingRef.current.pause();
        audioPlayingRef.current.currentTime = 0;
        audioPlayingRef.current = null;
      };
    }
  };

  const handleCloseNotification = (index) => {
    setNotifications((prev) => prev.filter((_, i) => i !== index));
  };

  const handleNotification = (notification) => {
    console.log("Notification received:", notification);
    const newNotification = {
      message: `message from ${notification.sender} : ${notification.content}`,
      key: new Date().getTime(),
      userName: notification.sender,
    };

    setNotifications([newNotification]);
    playSound("notificationSound");

    setTimeout(() => {
      setNotifications((prev) =>
        prev.filter((n) => n.key !== newNotification.key)
      );
    }, 5000);
  };

  const handleReplay = () => {
    setCount(0);
    activePage.key = "chat";
    activePage.name = "chat";
    activePage.url = "home/App/chat";
    activePage.description = "chat";
    setActivePage(dispatch, activePage);
  };

  const handleShowPassword = () => {
    setShowPassword(true);
  };

  const handleHidePassword = () => {
    setShowPassword(false);
  };

  let textColor = darkMode ? "white" : "dark";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  function LoginStatus() {
    application
      .post("/customerAccount/status")
      .then((response) => {
        const responseData = response.data.data;
        setProfileStatus(dispatch, responseData);
      })
      .catch((error) => {
        setProfileStatus(dispatch, error.response.data.data);
        if (error.response.status === 400) {
          navigateToHomePage();
        }
      });
  }

  useEffect(() => {
    if (AuthenticationService.allowUCMenus()) {
      LoginStatus();
    }
  }, []);

  const navigateToHomePage = () => {
    (activePage.key = "uc.settings"),
      (activePage.name = "User Profile"),
      (activePage.description = "Configuration"),
      (activePage.url = "home/app/uc/settings"),
      setActivePage(dispatch, activePage);
    return true;
  };
  const [openMessage, setOpenMessage] = useState(false);
  const [notifyMessage, setNotifyMessage] = useState({
    isOpen: false,
    type: "success",
  });
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleClick = () => {
    setOpenMessage(true);
  };

  // Close Snackbar
  const handleCloseMessage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenMessage(false);
    setNotify({ ...notify, isOpen: false });
  };

  useEffect(() => {
    setOpenCollapse(collapseName);
    setOpenNestedCollapse(itemParentName);
    // LoginStatus();
  }, []);

  //handle Notification Bar
  function handleNotificationBar() {
    setMiniSidenav(dispatch, true);
  }

  useEffect(() => {
    handleNotificationBar();
    return () => {};
  }, [dispatch, location]);

  //Link to Page clicked
  const menuClicked = (menu) => {
    activePage.key = menu.key;
    activePage.name = menu.name;
    activePage.url = menu.url;
    activePage.description = menu.description;
    setActivePage(dispatch, activePage);
    setRefreshComponent(true);
    setSearchText(dispatch, "");
  };

  const handleClose = () => {
    setOpen(false);
    setPassword("");
  };

  const isWebView21 = () => {
    return (
      /wv|WebView|Edge\/\d+/i.test(navigator.userAgent) ||
      window.isWebView21 === true
    );
  };

  const handleLogoutClick = () => {
    if (isWebView21()) {
      loggerFactory.info("click to logout event data send");
      window?.chrome?.webview?.postMessage(
        JSON.stringify({ eventType: "logout", data: "logout" })
      );
    } else if (
      AuthenticationService.allowRailwayDispatcher() ||
      AuthenticationService.allowMCXDispatcher() ||
      AuthenticationService.allowAgentMenus()
    ) {
      setOpen(true);
    } else {
      const payload = { status: "Logout" };
      application
        .post("/agentStatus/create", payload)
        .then((response) => {
          AuthenticationService.logout();
          loggerFactory.info(
            "user logout status update successfully",
            response
          );
        })
        .catch((error) => {
          AuthenticationService.logout();
          loggerFactory.debug("unable to update user logout status", error);
        })
        .finally(() => {
          AuthenticationService.logout();
          navigate("/site/log-out", { replace: true });
        });
    }
  };

  const encryptData = (data, secretKey) => {
    const iv = CryptoJS.lib.WordArray.random(16);
    const ciphertext = CryptoJS.AES.encrypt(
      data,
      CryptoJS.enc.Utf8.parse(secretKey),
      {
        iv: iv,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return iv.concat(ciphertext.ciphertext).toString(CryptoJS.enc.Base64);
  };

  async function handlePasswordConfirmation(data) {
    const encryptedUsername = AuthenticationService.getUser();
    const encryptedPassword = encryptData(data, window.secretKey);
    try {
      const response = await AuthenticationService.login(
        encryptedUsername,
        encryptedPassword
      );
      const user = response.data.messageDetail;
      if (user == "User has been successfully authenticated") {
        const payload = { status: "Logout" };
        application
          .post("/agentStatus/create", payload)
          .then((response) => {
            loggerFactory.info(
              "user logout status update successfully",
              response
            );
            AuthenticationService.logout();
            navigate("/site/log-out", { replace: true });
          })
          .catch((error) => {
            AuthenticationService.logout();
            navigate("/site/log-out", { replace: true });
            loggerFactory.debug("unable to update user logout status", error);
          });
      }
    } catch (error) {
      setNotify({
        isOpen: true,
        status: "Please enter valid password",
        message:
          error.response?.status === 400
            ? "wrong password ! try again.."
            : error.message,
        type: "error",
      });
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handlePasswordConfirmation(Password);
    }
  };
  const [refreshComponent, setRefreshComponent] = useState(false);
  const [counts, setCounts] = useState([]);
  const [groupCallList, setGroupCallList] = useState([]);
  const GetNotifications = "/uc/countNotification/list";

  function GetNotification() {
    application
      .post(GetNotifications)
      .then((res) => {
        const response = res.data.data;
        setCounts(response);
      })
      .catch((error) => {
        loggerFactory.debug(
          "error getting UC-count notification list :{}",
          error
        );
      });
  }

  const groupCallWaitingList = useCallback(async () => {
    try {
      const response = await application.post(`agent/checkCallStatus`);
      const data = response.data.data || [];
      setGroupCallList((prevList) => {
        if (JSON.stringify(prevList) !== JSON.stringify(data)) {
          setCallInWaiting(dispatch, data);
          return data;
        }
        return prevList;
      });
    } catch (error) {
      setGroupCallList((prevList) => {
        if (prevList.length > 0) {
          setCallInWaiting(dispatch, []);
        }
        return [];
      });
    }
  }, [dispatch]);

  useEffect(() => {
    if (AuthenticationService.allowRailwayDispatcher()) {
      const intervalId = setInterval(() => {
        groupCallWaitingList();
      }, 1500);
      return () => clearInterval(intervalId);
    }
  }, [groupCallWaitingList]);

  useEffect(() => {
    if (!AuthenticationService.allowUCMenus()) return;

    const interval = setInterval(() => {
      GetNotification();
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, [counts]);

  const renderNotifications = useMemo(() => {
    const countsByMessageType = (counts || []).reduce((acc, notification) => {
      acc[notification.messageType] = notification.count;
      return acc;
    }, {});

    return ucNotificationMenus.map((menu) => {
      if (menu.type === "divider") {
        return null;
      }
      if (AuthenticationService.isUCConferenceMenuHidden(menu.key)) {
        return null;
      }
      const count = countsByMessageType[menu.messageType] || 0;
      if (count) {
        return (
          <Link
            key={menu.key}
            onClick={() => menuClicked(menu)}
            to="javascript:void(0)"
          >
            <SidebarCollapse
              name={menu.name}
              icon={menu.icon}
              badge={count}
              count={count}
            />
          </Link>
        );
      } else {
        return null;
      }
    });
  }, [counts, ucNotificationMenus, refreshComponent]);

  // Render all the nested collapse items from the routes.js
  const renderNestedCollapse = (collapse) => {
    const template = collapse.map(({ name, route, key, href }) =>
      href ? (
        <Link
          key={key}
          href={href}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SideBarItem name={name} nested />
        </Link>
      ) : (
        <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
          <SideBarItem name={name} active={route === pathname} nested />
        </NavLink>
      )
    );

    return template;
  };
  // Render the all the collpases from the routes.js
  const renderCollapse = (collapses) =>
    collapses.map(({ name, collapse, route, href, key }) => {
      let returnValue;

      if (collapse) {
        returnValue = (
          <SideBarItem
            key={key}
            color={color}
            name={name}
            active={key === itemParentName ? "isParent" : false}
            open={openNestedCollapse === key}
            onClick={({ currentTarget }) =>
              openNestedCollapse === key &&
              currentTarget.classList.contains("MuiListItem-root")
                ? setOpenNestedCollapse(false)
                : setOpenNestedCollapse(key)
            }
          >
            {renderNestedCollapse(collapse)}
          </SideBarItem>
        );
      } else {
        returnValue = href ? (
          <Link
            href={href}
            key={key}
            target="_blank"
            rel="noreferrer"
            sx={{ textDecoration: "none" }}
          >
            <SideBarItem
              color={color}
              name={name}
              active={key === activePage.key}
            />
          </Link>
        ) : (
          <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
            <SideBarItem
              color={color}
              name={name}
              active={key === activePage.key}
            />
          </NavLink>
        );
      }
      return <SidebarList key={key}>{returnValue}</SidebarList>;
    });

  const renderRoutes = routes.map(
    ({
      type,
      name,
      icon,
      title,
      collapse,
      noCollapse,
      key,
      href,
      route,
      status,
    }) => {
      let returnValue;
      if (type === "collapse") {
        if (status === "Logout") {
          returnValue = (
            <Link
              onClick={() => handleLogoutClick()}
              key={key}
              sx={{ textDecoration: "none" }}
            >
              <SidebarCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}
              />
            </Link>
          );
        } else if (noCollapse && route) {
          returnValue = (
            <NavLink to={route} key={key}>
              <SidebarCollapse
                name={name}
                icon={icon}
                noCollapse={noCollapse}
                active={key === collapseName}
              >
                {collapse ? renderCollapse(collapse) : null}
              </SidebarCollapse>
            </NavLink>
          );
        } else {
          returnValue = (
            <SidebarCollapse
              key={key}
              name={name}
              icon={icon}
              active={key === collapseName}
              open={openCollapse === key}
              onClick={() =>
                openCollapse === key
                  ? setOpenCollapse(false)
                  : setOpenCollapse(key)
              }
            >
              {collapse ? renderCollapse(collapse) : null}
            </SidebarCollapse>
          );
        }
      } else if (type === "title") {
        returnValue = (
          <MDTypography
            key={key}
            color={textColor}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </MDTypography>
        );
      } else if (type === "divider") {
        returnValue = (
          <Divider
            key={key}
            light={
              (!darkMode && !whiteSidenav && !transparentSidenav) ||
              (darkMode && !transparentSidenav && whiteSidenav)
            }
          />
        );
      }

      return returnValue;
    }
  );

  let renderIvrMenu = null;

  renderIvrMenu = adminMenus.map((menu) => {
    return (
      <Link
        key={menu.key}
        onClick={() => menuClicked(menu)}
        to="javascript:void(0)"
      >
        <SidebarCollapse name={menu.name} icon={menu.icon} />
      </Link>
    );
  });

  let renderCallCenterMenu = null;

  renderCallCenterMenu = callCenterMenus.map((menu) => {
    return (
      <Link
        key={menu.key}
        onClick={() => menuClicked(menu)}
        to="javascript:void(0)"
      >
        <SidebarCollapse name={menu.name} icon={menu.icon} />
      </Link>
    );
  });

  let renderAdminMenu = null;

  renderAdminMenu = ivrMenus.map((menu) => {
    return (
      <Link
        key={menu.key}
        onClick={() => menuClicked(menu)}
        to="javascript:void(0)"
      >
        <SidebarCollapse name={menu.name} icon={menu.icon} />
      </Link>
    );
  });

  let renderquickMenu = null;

  const visibleQuickMenus = AuthenticationService.isBillingOnlyUser()
    ? quickMenus.filter((menu) => menu.key !== "auth-default")
    : quickMenus;

  renderquickMenu = visibleQuickMenus.map((menu) => {
    return (
      <Link
        key={menu.key}
        onClick={() => menuClicked(menu)}
        to="javascript:void(0)"
      >
        <SidebarCollapse name={menu.name} icon={menu.icon} />
      </Link>
    );
  });

  let agentMenuList = null;
  agentMenuList = agentMenus.map((menu) => {
    return (
      <Link
        key={menu.key}
        onClick={() => menuClicked(menu)}
        to="javascript:void(0)"
      >
        <SidebarCollapse name={menu.name} icon={menu.icon} />
      </Link>
    );
  });

  const renderChatMenu = useMemo(() => {
    return chatMenus.map((menu) => (
      <Link
        key={menu.key}
        onClick={(e) => {
          e.preventDefault();
          menuClicked(menu);
          // Don't clear notifications - they will be cleared when specific chat is opened
        }}
        to="javascript:void(0)"
      >
        <SidebarCollapse
          name={menu.name}
          icon={menu.icon}
          badge={count > 0 ? count : null}
          count={count}
          noHide={true}
        />
      </Link>
    ));
  }, [chatMenus, count]);

  // Get sorted list of users/groups with notifications (for use in chat component)
  const getSortedNotifications = () => {
    return Object.entries(notificationsByUser)
      .map(([id, data]) => ({
        id,
        ...data
      }))
      .sort((a, b) => b.count - a.count);
  };

  // Export function to clear specific user/group notification
  useEffect(() => {
    window.clearChatNotification = (userId) => {
      clearNotificationsForUser(userId);
    };
    window.getChatNotifications = () => getSortedNotifications();
    return () => {
      delete window.clearChatNotification;
      delete window.getChatNotifications;
    };
  }, [notificationsByUser]);

  let renderAgentMenus = null;
  renderAgentMenus = agentReportMoreVert.map((menu) => {
    return (
      <tooltip title={menu.name}>
        <Link
          key={menu.key}
          onClick={() => menuClicked(menu)}
          to="javascript:void(0)"
        >
          <SidebarCollapse name={menu.name} icon={menu.icon} />
        </Link>
      </tooltip>
    );
  });

  let renderConfigurationMenu = null;

  renderConfigurationMenu = configurationMenus.map((menu) => {
    if (
      !menu.disabled &&
      (menu.productionReady ||
        window.demoMode ||
        process.env.REACT_APP_MODE !== "ui-production")
    ) {
      return (
        <Link
          key={menu.key}
          onClick={() => menuClicked(menu)}
          to="javascript:void(0)"
        >
          <SidebarCollapse name={menu.name} icon={menu.icon} />
        </Link>
      );
    } else {
      return null;
    }
  });

  let renderEmailMenu = null;
  renderEmailMenu = emailMenus.map((menu) => {
    if (
      !menu.disabled &&
      (menu.productionReady ||
        window.demoMode ||
        process.env.REACT_APP_MODE !== "ui-production")
    ) {
      return (
        <Link
          key={menu.key}
          onClick={() => menuClicked(menu)}
          to="javascript:void(0)"
        >
          <SidebarCollapse name={menu.name} icon={menu.icon} />
        </Link>
      );
    } else {
      return null;
    }
  });

  let renderMenu = null;

  renderMenu = Menus.map((menu) => {
    return (
      <Link
        key={menu.key}
        onClick={() => menuClicked(menu)}
        to="javascript:void(0)"
      >
        <SidebarCollapse name={menu.name} icon={menu.icon} />
      </Link>
    );
  });

  let rendernmsMenu = null;

  rendernmsMenu = nmsQuickMenus.map((menu) => {
    return (
      <Link
        key={menu.key}
        onClick={() => menuClicked(menu)}
        to="javascript:void(0)"
      >
        <SidebarCollapse name={menu.name} icon={menu.icon} />
      </Link>
    );
  });

  let renderGroupQuickMenus = null;

  renderGroupQuickMenus = groupQuickMenus.map((menu) => {
    return (
      <Link
        key={menu.key}
        onClick={() => menuClicked(menu)}
        to="javascript:void(0)"
      >
        <SidebarCollapse name={menu.name} icon={menu.icon} />
      </Link>
    );
  });

  let renderConferenceMenus = null;

  renderConferenceMenus = conferenceQuickMenus.map((menu) => {
    return (
      <Link
        key={menu.key}
        onClick={() => menuClicked(menu)}
        to="javascript:void(0)"
      >
        <SidebarCollapse name={menu.name} icon={menu.icon} />
      </Link>
    );
  });

  const memoizedDispatcherQuickMenus = useMemo(
    () => dispatcherQuickMenus,
    [dispatcherQuickMenus]
  );

  const renderDispatcherMenus = useMemo(() => {
    return memoizedDispatcherQuickMenus.map((menu) => {
      const badgeCount =
        menu.key === "groupCallInQueue" ? groupCallList.length : undefined;

      return (
        <Link
          key={menu.key}
          onClick={() => menuClicked(menu)}
          to="javascript:void(0)"
        >
          <SidebarCollapse
            badge={badgeCount}
            count={badgeCount}
            noHide={true}
            name={menu.name}
            icon={menu.icon}
          />
        </Link>
      );
    });
  }, [memoizedDispatcherQuickMenus, groupCallList.length]);

  return (
    <>
      {notifications?.map((notification, index) => (
        <Snackbar
          key={notification.key}
          open={true}
          onClose={() => handleCloseNotification(index)}
          TransitionComponent={Slide}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{
            "& .MuiSnackbarContent-root": {
              marginRight: "20px",
              minWidth: "300px",
              maxWidth: "400px",
              justifyContent: "flex-end",
            },
          }}
        >
          <MuiAlert
            onClose={() => handleCloseNotification(index)}
            variant="filled"
            severity="success"
          >
            {notification.message}
            <Button
              color="inherit"
              size="small"
              sx={{ color: "red" }}
              onClick={() => handleReplay(notification)}
            >
              Replay
            </Button>
          </MuiAlert>
        </Snackbar>
      ))}
      <SidebarRoot
        {...rest}
        variant="permanent"
        ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
      >
        <MDBox pt={3} pb={1} px={1} textAlign="center">
          <MDBox display="flex" alignItems="center">
            {brand && (
              <MDBox
                component="img"
                src={darkMode ? "/logoDark.png" : "/logoLight.png"}
                alt="Brand"
                width="100%"
              />
            )}
            <MDBox
              width={!brandName && "100%"}
              sx={(theme) => sidebarLogoLabel(theme, { miniSidenav })}
            ></MDBox>
          </MDBox>
        </MDBox>
        <Divider
          light={
            (!darkMode && !whiteSidenav && !transparentSidenav) ||
            (darkMode && !transparentSidenav && whiteSidenav)
          }
        />
        {AuthenticationService.allowUCMenus() && (
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CTLUserStatus />
          </MDBox>
        )}
        {AuthenticationService.getExtensionNumber() && (
          <MDTypography
            variant="body2"
            color="info"
            sx={{ textAlign: "center" }}
          >
            {AuthenticationService.getExtensionNumber()}
          </MDTypography>
        )}
        <Divider
          light={
            (!darkMode && !whiteSidenav && !transparentSidenav) ||
            (darkMode && !transparentSidenav && whiteSidenav)
          }
        />
        {AuthenticationService.allowUCMenus() && (
          <List>{renderNotifications}</List>
        )}
        {!AuthenticationService.allowAgentMenus() &&
          !AuthenticationService.allowGroupAdmin() &&
          !AuthenticationService.allowUCConferenceMenus() &&
          !AuthenticationService.allowMCXDispatcher() &&
          !AuthenticationService.allowRailwayDispatcher() && (
            <List>{renderquickMenu}</List>
          )}

        {AuthenticationService.allowAgentMenus() && (
          <List>{agentMenuList}</List>
        )}
        {AuthenticationService.allowGroupAdmin() && (
          <List>{renderGroupQuickMenus}</List>
        )}
        {AuthenticationService.allowUCConferenceMenus() &&
          !AuthenticationService.allowMCXDispatcher() &&
          !AuthenticationService.allowRailwayDispatcher() && (
            <List>{renderConferenceMenus}</List>
          )}
        {AuthenticationService.allowRailwayDispatcher() && (
          <List>{renderDispatcherMenus}</List>
        )}

        {AuthenticationService.allowMCXDispatcher() && (
          <List>{renderDispatcherMenus}</List>
        )}

        {AuthenticationService.allowAdminMenus() &&
          !AuthenticationService.allowMCXDispatcher() &&
          !AuthenticationService.allowRailwayDispatcher() && (
            <List>{renderConfigurationMenu}</List>
          )}
        {AuthenticationService.allowAdminMenus() &&
          !AuthenticationService.allowMCXDispatcher() &&
          !AuthenticationService.allowRailwayDispatcher() && (
            <List>{renderEmailMenu}</List>
          )}
        {AuthenticationService.allowChat() && <List>{renderChatMenu}</List>}
        {AuthenticationService.allowAgentMenus() && (
          <List>{renderAgentMenus}</List>
        )}

        <List>{renderMenu}</List>
        <List>{renderRoutes}</List>
        <MDBox
          px={1}
          py={0.5}
          sx={{
            position: "absolute",
            bottom: 4,
            left: 0,
            right: 0,
            textAlign: "center",
          }}
        >
          <MDTypography
            variant="caption"
            color={darkMode ? "white" : "dark"}
            sx={{ fontSize: "0.6rem", opacity: 0.6 }}
          >
            {window.application || "Coral"} {process.env.REACT_APP_VERSION}
          </MDTypography>
        </MDBox>
      </SidebarRoot>

      <Dialog open={open} onClose={handleClose}>
        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDBox
            pt={2}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Card>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={6}
                mt={-2}
                py={2}
                mb={1}
                textAlign="center"
              >
                <MDTypography
                  variant="h6"
                  fontWeight="medium"
                  color="white"
                  mt={1}
                >
                  Secure User Logout with Password Confirmation
                </MDTypography>
              </MDBox>
              <MDBox pt={6} pb={4} px={2}>
                <MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      type={showPassword ? "text" : "password"}
                      label="Password"
                      variant="standard"
                      fullWidth
                      value={Password}
                      onKeyPress={handleKeyPress}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="off"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onMouseDown={handleShowPassword}
                              onMouseUp={handleHidePassword}
                              edge="end"
                              style={{ margin: "1px" }}
                            >
                              {showPassword ? (
                                <Visibility color="success" />
                              ) : (
                                <VisibilityOff color="info" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </MDBox>
                </MDBox>
                <MDBox mt={6}>
                  <MDButton
                    variant="gradient"
                    fullWidth
                    color="error"
                    onClick={() => handlePasswordConfirmation(Password)}
                  >
                    Logout Confirm
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </DialogContent>
      </Dialog>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </>
  );
}

// Setting default values for the props of CTLSideBar
CTLSideBar.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the CTLSideBar
CTLSideBar.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CTLSideBar;
